"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserPrefillGhost = void 0;
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var react_1 = __importDefault(require("react"));
var userPrefillStyles = __importStar(require("./UserPrefill.css"));
var styles = __importStar(require("./UserPrefillGhost.css"));
var LineHeightWrapper = function (_a) {
    var children = _a.children, height = _a.height;
    return (react_1.default.createElement(kaleidoscope_1.Stack, { justify: "center", style: { height: height } }, children));
};
var UserPrefillGhost = function (_a) {
    var esignEnabled = _a.esignEnabled;
    return (react_1.default.createElement(kaleidoscope_1.Card, { className: userPrefillStyles.card },
        react_1.default.createElement(kaleidoscope_1.Stack, { gap: "m", direction: "vertical", padding: "l" },
            esignEnabled && (react_1.default.createElement(kaleidoscope_1.Stack, null,
                react_1.default.createElement(kaleidoscope_1.Stack, { justify: "spaceBetween", direction: "horizontal", className: styles.ghostEsignMetaStack, align: "center" },
                    react_1.default.createElement(kaleidoscope_1.GhostBlock, { style: { width: "115px" } }),
                    react_1.default.createElement(kaleidoscope_1.GhostBlock, { style: { width: "77px" } })),
                react_1.default.createElement(LineHeightWrapper, { height: "148px" },
                    react_1.default.createElement(kaleidoscope_1.GhostBlock, { className: styles.ghostSignature })),
                react_1.default.createElement("div", { className: styles.ghostSeparator }))),
            react_1.default.createElement(kaleidoscope_1.Stack, { gap: "s", direction: "horizontal", align: "center" },
                react_1.default.createElement(kaleidoscope_1.GhostBlock, { className: styles.ghostAvatar }),
                react_1.default.createElement(kaleidoscope_1.Stack, { gap: "xs" },
                    react_1.default.createElement(LineHeightWrapper, { height: "18px" },
                        react_1.default.createElement(kaleidoscope_1.GhostBlock, { style: { width: "191px" } })),
                    react_1.default.createElement(LineHeightWrapper, { height: "18px" },
                        react_1.default.createElement(kaleidoscope_1.GhostBlock, { style: { width: "136px" } })))),
            react_1.default.createElement("div", { className: styles.ghostSeparator }),
            react_1.default.createElement(LineHeightWrapper, { height: "24px" },
                react_1.default.createElement(kaleidoscope_1.GhostBlock, { style: { width: "191px" } })))));
};
exports.UserPrefillGhost = UserPrefillGhost;
